import api from "../../../../core/api/api";
import { targetInfoType } from "../target/Types";
import { validationUtils } from "../utils";
import { getParams, addMethods } from "./wizards-methods-helper";
// Maps the wizard-layer target id (e.g. "BIGQUERY") to the WizardClassDetails enum
// name that resolves to the writer-side wizard on the backend. Without this,
// "BIGQUERY" dispatches to BigQueryReaderWizard instead of BigQueryWriterWizard.
const TARGET_TYPE_OVERRIDES: Record<string, string> = {
    SQLSERVER: "MSSQL",
    BIGQUERY: "BIGQUERYWRITER",
    FABRICMIRRORWRITER: "FABRICMIRROR"
};

async function validateConnection(target: string, targetInfo: targetInfoType) {
    const targetName: string = validationUtils.getTargetType(target).toUpperCase();
    const APIParams: Object = await validationUtils.getParams(targetName, targetInfo);
    try {
        // All wizard types (ICDCWizard and TargetWizard) are routed through WizardHelper
        const type = TARGET_TYPE_OVERRIDES[targetName] ?? targetName;
        return await api.WizardHelper_ValidateConnection(type, APIParams);
    } catch (e) {
        return new Error(e);
    }
}

async function checkTargetPrivileges(target: string, targetInfo: targetInfoType) {
    const targetName: string = validationUtils.getTargetType(target).toUpperCase();
    const APIParams: Object = await validationUtils.getParams(targetName, targetInfo);
    APIParams["ConnectionURL"] = APIParams["ConnectionURL"] ?? APIParams["URL"];
    delete APIParams["URL"];

    try {
        // All wizard types (ICDCWizard and TargetWizard) are routed through WizardHelper
        const type = TARGET_TYPE_OVERRIDES[targetName] ?? targetName;
        return await api.WizardHelper_CheckTargetPrivileges(type, APIParams);
    } catch (e) {
        return new Error(e);
    }
}

async function checkSourcePrivileges(
    sourceName: string,
    sourceParams: targetInfoType | Record<string, any>,
    wizardType?: string | null
) {
    addMethods(sourceParams);
    const isDownStreamFilled = sourceParams.get("supportDownStreamCapture");
    const APIParams = await getParams(sourceName, sourceParams, isDownStreamFilled);
    const agentName = sourceParams.get("agentName") || null;
    const metaObjectFQN = sourceParams.get("objectID") || null;
    const adapterName_version = sourceParams.get("sourceAdapter") || null;
    try {
        // All source privilege checks go through WizardHelper
        const type = sourceName.toUpperCase() === "SQLSERVER" ? "MSSQL" : sourceName.toUpperCase();
        // wizardType is resolved by the caller from the flow flags.
        APIParams["wizardType"] = wizardType ?? null;
        return await api.WizardHelper_CheckPrivileges(type, APIParams, agentName, metaObjectFQN, adapterName_version);
    } catch (e) {
        return new Error(e);
    }
}

export { validateConnection, checkTargetPrivileges, checkSourcePrivileges };
